import React from 'react';
import Modal from '../../components/mweb/Modal/Modal';

const OrderSummaryModal = ({ visible, summary, onCancel }) => {
  let title = 'Order Summary';
  if (summary?.billingDetails) {
    const { totalItems = 0 } = summary?.billingDetails || {};
    title = `Order Summary for ${
      totalItems > 1 ? `${totalItems} items` : `${totalItems} item`
    }`;
  }
  return (
    <Modal
      visible={visible}
      onCancel={onCancel}
      title={title}
      wrapClassName="order-summary-modal"
    >
      {summary?.summaryOrder?.map(detail => {
        if (!detail.amount && detail.hideEmpty) return false;
        return (
          <div
            className="order-summary-modal--item"
            style={{ color: detail.hexcolors }}
            key={detail.key}
          >
            <div className="key">{detail.text}</div>
            {detail.key === 'deliveryCharges' && (
              <div className="value">
                {detail.amount === 0 ? (
                  <span>FREE</span>
                ) : (
                  <span>&#8377;{detail.amount}</span>
                )}
              </div>
            )}
            {detail.key !== 'deliveryCharges' && (
              <div className="value">
                {detail.showSign ? `${detail.showSign} ` : ''}&#8377;
                {detail.amount}
              </div>
            )}
          </div>
        );
      })}
    </Modal>
  );
};

export default OrderSummaryModal;
